import { parsePhoneNumberFromString } from "libphonenumber-js";

export const normalisePhoneNumber = (phoneNumber: string): string | null => {
    return parsePhoneNumberFromString(phoneNumber, "GB")?.number ?? null;
};
